import React from 'react';
import Modal from 'react-bootstrap/Modal';

interface ModalRemoveSearchProps {
  modalRemoveSearchOpened: boolean;
  setModalRemoveSearchOpened: React.Dispatch<React.SetStateAction<boolean>>;
  handleDeleteFilter: () => void;
}

const ModalRemoveSearch = (props: ModalRemoveSearchProps) => {
  const { modalRemoveSearchOpened, setModalRemoveSearchOpened, handleDeleteFilter } = props;

  return (
    <Modal
      show={modalRemoveSearchOpened}
      size="sm"
      onHide={() => setModalRemoveSearchOpened(false)}
    >
      <div className="modal-content">
        <div className="modal-header">
          <h6 className="modal-title" id="modalLabel">
            Deseja excluir a pesquisa selecionada?
          </h6>
          <button
            aria-label="Close"
            className="close"
            type="button"
            onClick={() => setModalRemoveSearchOpened(false)}
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="form-row">
            <button
              type="button"
              className="btn btn-md btn-block btn-danger"
              onClick={() => {
                handleDeleteFilter();
                setModalRemoveSearchOpened(false);
              }}
            >
              Confirmar
            </button>
            <button
              type="button"
              className="btn btn-md btn-block btn-primary"
              onClick={() => setModalRemoveSearchOpened(false)}
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ModalRemoveSearch;
